import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Placement from "@/pages/Placement";
import OurHomes from "@/pages/OurHomes";
import Chasnell from "@/pages/Chasnell";
import Contact from "@/pages/Contact";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReferralInterest from "@/pages/AdminReferralInterest";
import AdminLogin from "@/pages/AdminLogin";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppShell() {
  const location = useLocation();

  // Handle the OAuth return (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/placement" element={<Placement />} />
          <Route path="/homes" element={<OurHomes />} />
          <Route path="/chasnell" element={<Chasnell />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/referrals" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/referral-interest" element={<ProtectedRoute><AdminReferralInterest /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppShell />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
